import { IGameState } from '../../Game/IGameState';
import { setKeys } from '../PlayerInventoryHelper';

export function receiveKeys(state: IGameState, keys: number) {
    return {
        ...state,
        playerState: setKeys(state.playerState, state.playerState.keys + keys),
    };
}
